<template>
  <div :class="['formDatePicker', { 'formDatePicker--disablePaddings': disablePaddings }]">
    <label class="formDatePicker__label" :for="name">
      <date-picker
        :id="name"
        :value="value"
        :name="name"
        :placeholder="placeholder"
        :disabled="disabled"
        :editable="false"
        type="date"
        value-type="YYYY-MM-DD"
        @input="onInput"
        @change="$emit('change')"
        :disabled-date="disabledDate"
      />
      <span
        :class="[
          'formDatePicker__labelText',
          { 'formDatePicker__labelText--top': value || placeholder },
        ]"
      >
        {{ label }}
      </span>
    </label>
    <slot />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pl';
export default {
  name: 'FormDatePicker',
  components: {
    DatePicker,
  },
  props: {
    name: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disablePaddings: {
      type: Boolean,
      default: false,
    },
    disabledDate: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    onInput(e) {
      this.$emit('input', e);
      this.$emit('emitObject', {
        name: this.name,
        value: e,
      });
    },
  },
};
</script>

<style lang="scss">
.formDatePicker {
  $root: &;
  position: relative;
  padding-top: 1.5rem;

  &.is-invalid {
    #{$root}__label::after {
      @include icomoon('wrong');
      font-size: 2.5rem;
      color: $cBadgeProm;
      position: absolute;
      top: 50%;
      right: 1.5rem;
      transform: translateY(-50%);
    }

    #{$root}__input {
      border: 2px solid $cBadgeProm;
    }
  }

  .mx-datepicker {
    width: 100%;
  }

  input {
    display: inline-block;
    position: relative;
    border: 1px solid #e2e2e2;
    border-radius: 4px;
    color: $cMainLight;
    font-size: 1.4rem;
    height: 4.8rem;
    width: 100%;
    padding: 1.6rem 2rem;
    transition: border $tr;
    box-shadow: none;

    &::placeholder {
      color: $cAddDark02;
    }

    &:active:not(:disabled) ~ #{$root}__labelText,
    &:focus:not(:disabled) ~ #{$root}__labelText {
      top: 0;
    }

    &:disabled {
      background-color: $cBg;

      & ~ #{$root}__labelText {
        background-color: transparent;
      }
    }

    &:hover,
    &:focus {
      border-color: $cAddLight;
    }
  }

  &__label {
    display: block;
    position: relative;
  }

  &__labelText {
    white-space: nowrap;
    overflow: hidden;
    max-width: calc(100% - 2rem);
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: 600;
    color: $cMainDark;
    background-color: $cWhite;
    margin-left: 1rem;
    padding: 0 1rem;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    left: 0;
    z-index: 10;
    transition: top $trM;
    pointer-events: none;

    &--top {
      top: 0;
    }
  }

  &__error {
    display: inline-block;
    color: $cBadgeProm;
    font-size: 1.4rem;
    line-height: 1.6rem;
    transition: color $tr, margin $tr;
    margin: 0.3rem 0 0.4rem 0;
  }

  &--disablePaddings {
    padding-top: 0;
  }
}

.mx-calendar {
  .cell {
    vertical-align: middle;
  }
}
</style>
